export default __webpack_public_path__ + "875ce4a918d138bec98e5643230a7dfb.svg";